import { PaymentMethodEnum } from "../enums/PaymentMethodEnum"

export interface ClickToPayLegalLinkSet {
  network: "Mastercard" | "Visa"
  termsHref: string
  privacyNoticeHref: string
}

interface ClickToPayLegalLinkProvider {
  paymentMethod: "master" | "visa"
  network: ClickToPayLegalLinkSet["network"]
  createLinks: (locale: string) => Omit<ClickToPayLegalLinkSet, "network">
}

const toLegalLocale = (locale: string): string => locale.replace("_", "-").toLowerCase()

const LEGAL_LINK_PROVIDERS: ClickToPayLegalLinkProvider[] = [
  {
    paymentMethod: "master",
    network: "Mastercard",
    createLinks: locale => ({
      termsHref: `https://www.mastercard.com/global/click-to-pay/${locale}/terms-of-use.html`,
      privacyNoticeHref: `https://www.mastercard.com/global/click-to-pay/${locale}/privacy-notice.html`,
    }),
  },
  {
    paymentMethod: "visa",
    network: "Visa",
    // Visa's localized routes return 404, so use the working English documents.
    createLinks: () => ({
      termsHref: "https://usa.visa.com/legal/checkout/terms-of-service.html",
      privacyNoticeHref: "https://www.visa.com/en-us/legal/global-privacy-notice.html",
    }),
  },
]

/** Returns the approved legal documents for every supported Click to Pay network shown on the screen. */
export const getClickToPayLegalLinks = (paymentMethod: PaymentMethodEnum, locale: string): ClickToPayLegalLinkSet[] => {
  const enabledPaymentMethods = paymentMethod.split(",")
  const legalLocale = toLegalLocale(locale)

  return LEGAL_LINK_PROVIDERS.filter(provider => enabledPaymentMethods.indexOf(provider.paymentMethod) >= 0).map(
    provider => ({
      network: provider.network,
      ...provider.createLinks(legalLocale),
    })
  )
}
